import { Box, Dialog, DialogContent, DialogTitle, Grid, Slide, Button } from '@mui/material';
import { makeStyles, useTheme } from '@mui/styles';
import { getUrl } from '@utils/ApiAction';
import { currencyFormat , storePaths } from '@utils/Tools';
import useNotificationLoading from '@utils/useNotificationLoading';
import _ from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate , useLocation } from 'react-router-dom';

import { FiX, FiChevronRight } from "react-icons/fi";
import { GiElectric } from "react-icons/gi";


import DialogDesign from '@components/DialogDesign';
import ExtendPlan from './ExtendPlan';

//Dialog
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const INITIAL_EXTEND = { 'open': false };

export default function PlanHistories() {
    let navigate = useNavigate();
    let location = useLocation();
    const [state, setState] = useState({
        data: [],
        profitLimit: [],
        lockedCredit: [],
    });

    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const isMountedRef = useRef(null);
    const { addAlert, setLoading } = useNotificationLoading();

    //Dialog
    const [dialog, setDialog] = useState({
        open: false,
        data: [],
    });
    const [ extend , setExtend] = useState(INITIAL_EXTEND);
    const handleClickOpen = (data) => {
        setDialog({ ...dialog, open: true, data: data });
    };
    const handleClose = () => {
        setDialog({ ...dialog, open: false, data: [] });
        setExtend(INITIAL_EXTEND);
    };

    useEffect(() => {
        getData();
        // eslint-disable-next-line
    }, [state.pageIndex]);

    const  getData = () =>{
        isMountedRef.current = true;
        setLoading(true);
        getUrl('/user/plan-histories').then(response => {
            if (response.status && isMountedRef.current) {
                setState({ ...state, data: response.data.plan_histories, profitLimit: response.data.total_credit_limit, lockedCredit: response.data.locked_roi });
            }
        }).catch(error => {
            addAlert('', error.message || t('error.contactSupport'), 'error', '');
        }).finally(() => {
            setLoading(false);
        });
        return () => isMountedRef.current = false;
    }

    const clickBack = () =>{
        setExtend({ ...extend, open: false });
        getData();
        let plan = _.clone(dialog?.data);
        let newData =_.find(state.data, { id: plan?.id });
        if(_.size(newData) > 0){
            setDialog({...dialog , data: newData});
        }
    }

    return (
        <div className='p-b-150' style={{ minHeight: '100vh', overflowY: 'hidden' }}>

            <div className='p-lr-24 p-b-40'>
                <p className='p-b-15 cl-white'>{t('package.purchasePackage')}</p>
                <div className='glass-box2 p-all-15  bor15'>
                    <div className='flex-m w-full'>
                        <div style={{ width: 115, maxWidth: '50%', filter:'drop-shadow(-1px 2px 3px #fff3)' }}>
                            <img src='/images/general/machine.png' alt="machine" className='w-full' />
                        </div>
                        <div className='p-l-20 w-full p-b-5'>
                            <p className='fs-16 cl-white p-b-5'><b>{t('package.descTitle')}</b></p>
                            <div className='cl-label fs-13 p-b-12'>
                                <p>{t('package.desc1')}</p>
                                <p>{t('package.desc2')}</p>
                            </div>
                            <div className='bor5 bkg-theme pointer shadow-button p-lr-10 p-tb-8 txt-center fs-14 translateX' style={{width:'fit-content', minWidth:110}}  onClick={() => navigate("/packages/purchase", { state: { from: storePaths(location) } })}>
                                <p>{t('button.activate')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='p-lr-20'>
                <div>
                    <p className=' cl-white'>{t('wallet.planHistories')}</p>
                    {/* <div className='flex-c-m fs-33 cl-theme p-t-15'>
                        <p style={{  fontWeight: 'bold', opacity: 0.8 }}>$ <span style={{ fontFamily: 'Nunito' }}>{currencyFormat(state.profitLimit.profit_limit_balance || 0.00)}{" / " + currencyFormat(state.profitLimit.profit_limit || 0.00)}</span></p>
                    </div> */}
                    {/* {
                        _.size(state.lockedCredit) > 0 ?
                            <>
                                <p style={{ paddingTop: 10, paddingLeft: 32, fontFamily: 'Nunito', fontSize: 14, color: 'white', 'opacity': 0.65 }}>{t('package.lockedROI')}</p>
                                {
                                    _.map(state.lockedCredit, (detail, index) => {
                                        return (
                                            <div key={index}>
                                                <div className='flex-sb-m p-lr-32' style={{ display: 'flex', justifyContent: 'center' }}>
                                                    <div style={{ fontSize: 32, color: 'white', opacity: 0.8 }}>{'$ ' + currencyFormat(detail.locked || 0.00) + ' '}<span style={{ fontFamily: 'Nunito', fontSize: 18 }}>{(i18n.resolvedLanguage ? detail?.wallet?.name[i18n.resolvedLanguage] : detail?.wallet?.name['en'])}</span></div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </>
                            : null
                    } */}
                </div>
                {
                    _.size(state.data) > 0 ?
                        <>
                            {
                                _.map(state.data, (detail, index) => {
                                    let percentage = Math.floor((detail?.energy_balance || 0) / (detail?.total_energy || 0) * 100) ; 
                                    return (
                                        <div key={index} className='pointer box-glass m-tb-25 p-tb-16 p-lr-10' onClick={() => handleClickOpen(detail)}>{/* borderTop: index !== 0 ? '3px solid #202E63' : '' */}
                                            <div className='w-full flex-sb-m p-b-15' style={{gap:15}}>
                                                <div className='flex-m w-full' style={{gap:15}}>
                                                    <div style={{minWidth:55, width: 90, aspectRatio:'1/1', objectFit: 'cover'}}>
                                                        {
                                                            detail?.plan?.plan_logo?.file_name ?
                                                                <img  className='w-full h-full'  src={detail.plan.plan_logo.file_name} alt="package" />
                                                                :
                                                                <img  className='w-full h-full'  src='/images/wallet/coin2.png' alt="package" />
                                                        }
                                                    </div>
                                                    <div className='w-full cl-white'>
                                                        <p><b>{detail?.plan_name[i18n.resolvedLanguage] || detail?.plan_name['en']}</b></p>
                                                        <p className='fs-13 p-t-5 cl-label ' style={{ fontStyle:'italic' }}>{`${t('package.energy')} : ${detail?.energy_balance} / ${detail?.total_energy}`}</p>
                                                       <p></p>
                                                        <div className='p-t-10 w-full pos-relative flex-m'>
                                                            <div className='energybar-bkg w-full m-l-25' style={{ height: 20 }}>
                                                                {
                                                                    (((detail?.energy_balance || 0) > 0) && ((detail?.total_energy || 0) > 0)) ?
                                                                        <div className='energybar animation-bkg ' style={{ height: 20, width: `${percentage >= 0 && percentage <= 5 ? '5' : percentage}%` }}></div>
                                                                        :
                                                                        <div className='energybar' style={{ height: 20, width: '0%' }}></div>
                                                                }

                                                            </div>
                                                            <div className={`${percentage >= 0 ? 'bkg-energy-on animation-pulse' : 'bkg-energy-off'}  flex-c-m pos-absolute`} style={{ height: 30, width: 30, borderRadius: '100%' }}>
                                                                <GiElectric className='clwhite fs-21' style={{filter: 'drop-shadow(1px 1px 0.5px #0005)'}}/>
                                                            </div>
                                                        </div>
                                                        {/* <p className='fs-13 p-t-5 cl-label txt_truncate1'>ID: {detail.ulid}</p> */}
                                                        {/* <p className='fs-13 p-t-5 cl-label' style={{ whiteSpace: "break-spaces" }}>{detail.created_at}</p> */}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className='btn-energy bor10 p-lr-8 p-tb-10 m-t-20'>
                                                        {/* <p className='p-r-10'>{currencyFormat(detail.price * 1, 2)}</p>
                                                        <FiChevronRight /> */}
                                                        <div className='btn-energy-img'>
                                                            <img src='/images/stake/energy.png' alt="button" className='w-full' />
                                                        </div>
                                                        <p className='txt-center fs-14' style={{marginTop: -5}}>{t('button.extend')}</p>
                                                    </div>
                                                    <p className='cl-label fs-13 txt-upper p-t-5'>{(detail?.details?.unlocked == true ? t('package.complete') : '')}</p>
                                                </div>
                                            </div>

                                            {/* <Grid container display="flex" flexDirection="column" justifyContent="space-between" style={{ padding: 5, color: '#B6B8C3' }}>
                                                <p>{t('package.dailyMission')}</p>
                                             
                                            </Grid> */}
                                            {/* {
                                                detail?.daily_mission == true ?
                                                    <Grid container display="flex">
                                                        <Grid item xs={12}>
                                                            <progress value={1} style={{ width: "100%" }} />
                                                        </Grid>
                                                    </Grid>
                                                    :
                                                    <Grid container display="flex">
                                                        <Grid item xs={10}>
                                                            <progress value={detail?.daily_mission_count / detail?.plan?.extra_setting?.min_match} style={{ width: "100%" }} />
                                                        </Grid>
                                                        <Grid item xs={2} className='fs-16' style={{ color: '#B6B8C3', textAlign: 'center' }}>{detail?.daily_mission_count + ' / ' + detail?.plan?.extra_setting?.min_match}</Grid>
                                                    </Grid>
                                            } */}
                                            {/* <Grid container display="flex" flexDirection="column" justifyContent="space-between" style={{ padding: 5, color: '#B6B8C3' }}>
                                                <p>{t('package.monthlyMission') + ` (${t('package.starts')} ` + (detail.roi.start_date || '-') + ')'}</p>
                                            </Grid> */}
                                            {/* {
                                                detail?.monthly_mission == true ?
                                                    <Grid container display="flex" style={{ paddingTop: 5 }}>
                                                        <Grid item xs={12}>
                                                            <progress value={1} style={{ width: "100%" }} />
                                                        </Grid>
                                                    </Grid>
                                                    :
                                                    <Grid container display="flex">
                                                        <Grid item xs={10}>
                                                            <progress value={detail?.roi?.mission_count / 30} style={{ width: "100%" }} />
                                                        </Grid>
                                                        <Grid item xs={2} className='fs-16' style={{ color: '#B6B8C3', textAlign: 'center' }}>{detail?.roi?.mission_count + ` / 30`}</Grid>
                                                    </Grid>
                                            } */}
                                        </div>
                                    )
                                })
                            }
                        </>
                        :
                        <div className='txt-center' style={{ paddingTop: 40 }}>
                            <img src='/images/general/no-transaction.png' alt='no-transaction' style={{ width: 180 }} loading='lazy' />
                            <p className='cl-white fs-16' style={{ paddingTop: 16, fontWeight: 600 }}>{t('table.noRecord')}</p>
                        </div>
                }
                <Dialog
                    open={dialog.open}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={handleClose}
                >
                    <DialogDesign>
                        <div className='dialog-btn-close' onClick={() => handleClose()}>
                            <div className=' flex-c-m animate-spin pointer'>
                                <FiX className='fs-23 cl-theme' />
                            </div>
                        </div>
                        {
                            extend?.open ?
                                <ExtendPlan history={dialog.data} getData={getData} />
                                :
                                <>
                                    <div className='w-full txt-center txt-upper lh-11 p-b-20' >
                                        <p className='fs-24 cl-theme'><b>{_.includes(i18n.resolvedLanguage, dialog?.data?.plan_name) ? dialog?.data?.plan_name[i18n.resolvedLanguage] : dialog?.data?.plan_name?.['en']}</b></p>
                                        <p className='fs-18 txt-title p-t-10'>{t('wallet.transactionDetails')}</p>
                                    </div>
                                    <div className='divider-dark' />
                                    <div>
                                        {
                                            dialog.data?.plan?.plan_logo?.file_name ?
                                                <div style={{ textAlign: 'center' }}>
                                                    <img style={{ width: '110px', height: '110px', objectFit: 'cover' }} src={dialog.data.plan.plan_logo.file_name} alt="package" />
                                                </div>
                                                : null
                                        }
                                        <div className='p-tb-20 flex-col-m ' style={{ gap: 20 }}>
                                            <div>
                                                <p className='p-b-5 txt-upper fs-13 cl-label'>{t('wallet.transactionId')}:</p>
                                                <p className='fs-15' style={{ fontWeight: 'bold', wordBreak: 'break-all' }}>{dialog.data.ulid}</p>
                                            </div>
                                            <div>
                                                <p className='p-b-5 txt-upper fs-13 cl-label'>{t('wallet.dateTime')}</p>
                                                <p className='fs-15' style={{ fontWeight: 'bold' }}>{dialog?.data?.created_at}</p>
                                            </div>
                                            <div>
                                                <p className='p-b-5 txt-upper fs-13 cl-label'>{t('package.recipientUsername')}:</p>
                                                <p className='fs-15' style={{ fontWeight: 'bold', wordBreak: 'break-all' }}>{dialog?.data?.recipient?.username}</p>
                                            </div>
                                            <div>
                                                <p className='p-b-5 txt-upper fs-13 cl-label'>{t('wallet.status')}</p>
                                                <p className='fs-15' style={{ fontWeight: 'bold' }}>{_.includes(i18n.resolvedLanguage, dialog?.data?.status_display) ? dialog?.data?.status_display[i18n.resolvedLanguage] : dialog?.data?.status_display?.['en']}</p>
                                            </div>
                                            <div>
                                                <p className='p-b-5 txt-upper fs-13 cl-label'>{t('package.serviceFee')}</p>
                                                <p className='fs-15' style={{ fontWeight: 'bold' }}>{currencyFormat((dialog?.data?.extra_setting?.service_fees || 0) * 1, 2)}</p>
                                            </div>
                                            <div>
                                                <p className='p-b-5 txt-upper fs-13 cl-label'>{t('package.totalPrice')}</p>
                                                <p className='fs-15' style={{ fontWeight: 'bold' }}>{currencyFormat((dialog?.data?.price || 0) * 1, 2)}</p>
                                            </div>
                                            <div>
                                                <p className='p-b-5 txt-upper fs-13 cl-label'>{t('package.energy')}</p>
                                                <p className='fs-15' style={{ fontWeight: 'bold' }}>{`${dialog.data?.energy_balance} / ${dialog.data?.total_energy}`}</p>
                                            </div>
                                            {/* <div>
                                    <p className='p-b-5 txt-upper fs-13 cl-label'>{t('wallet.profitLimit')}</p>
                                    <p className='fs-15' style={{ fontWeight: 'bold' }}>{dialog?.data?.profit_limit_balance + ' / ' + dialog?.data?.profit_limit}</p>
                                </div>
                                <div>
                                    <p className='p-b-5 txt-upper fs-13 cl-label'>{t('package.dailyMission')}</p>
                                    <p className='fs-15' style={{ fontWeight: 'bold' }}>{dialog?.data?.plan?.extra_setting?.min_match + ' ' + t('package.missionRequirement') + ' ' + dialog?.data?.plan?.extra_setting?.min_amount}</p>
                                </div>
                                <div>
                                    <p className='p-b-5 txt-upper fs-13 cl-label'>{t('package.monthlyMission')}</p>
                                    <p className='fs-15' style={{ fontWeight: 'bold' }}>{dialog?.data?.plan?.extra_setting?.min_match + ' ' + t('package.missionRequirement') + ' ' + dialog?.data?.plan?.extra_setting?.min_amount + ` (30${t('package.days')})`}</p>
                                </div> */}
                                        </div>
                                        <div className='divider-dark' />
                                        <div className='p-t-20 flex-sb-m cl-theme' style={{ fontWeight: 'bold' }}>
                                            <p className='p-b-5 txt-upper lh-12' style={{ whiteSpace: 'break-spaces' }}>{t('wallet.totalAmount')}</p>
                                            <p className='fs-21 txt-right' style={{ wordBreak: 'break-all' }}> {currencyFormat((parseFloat(dialog.data?.price) + parseFloat(dialog?.data?.extra_setting?.service_fees) || 0) * 1, 4)}</p>
                                        </div>
                                    </div>
                                </>
                        }
                        
                        {
                            _.includes([20, 40], dialog?.data?.status) &&

                            <div className='m-t-20'>
                                {
                                    extend?.open ?
                                        <div className='flex-c-m' style={{ flex: '1 1', width: '100%', gap: 20 }}>
                                            <div className='flex-c-m' style={{ flex: '1' }}>
                                                <Button variant="outlined" onClick={clickBack}>
                                                    {t('button.back')}
                                                </Button>
                                            </div>
                                        </div>

                                        :
                                        <Button variant="contained" onClick={() => setExtend({ ...extend, open: true })}>{t('button.extend')}</Button>
                                }
                            </div>
                        }
                    </DialogDesign>
                </Dialog>
            </div>
        </div>
    )
}

const useStyles = makeStyles(theme => ({
}));